export default __webpack_public_path__ + "static/media/downword.87836df4.svg";